import * as index from './index';
index.MultiSelect.Inject(index.CheckBoxSelection);
index.ListBox.Inject(index.CheckBoxSelection);
export * from './index';
